import type { SanitizationContextConfig } from './types';

export const GUEST_TOKEN_REGEX = /[a-zA-Z0-9]{40}/;
export const REDACTED_TEXT = '***';

/* --- Sanitization contexts --- */

export const GUEST_TOKEN = 'guestToken';

/* --- Payload paths --- */

export const ERROR_CONTEXT_PATH = 'body.trace.extra.errorContext';

export const GUEST_TOKEN_SANITIZER_PATHS = [
  'body.message.body',
  'body.trace.exception.description',
  'body.trace.exception.message',
  'request.url',
];

/* --- Sanitizers --- */

export const sanitizeGuestToken = (text: string) => text.replace(GUEST_TOKEN_REGEX, REDACTED_TEXT);

/* --- Sanitization context --- */

export const sanitizationContexts: SanitizationContextConfig = {
  [GUEST_TOKEN]: {
    paths: GUEST_TOKEN_SANITIZER_PATHS,
    sanitizers: [
      sanitizeGuestToken,
    ],
  },
};
